// Returns '#000000' or '#ffffff' based on WCAG relative luminance of the given hex color
export function useColorContrast() {
  function getContrastColor(hex: string): string {
    const c = hex.replace('#', '')
    const r = parseInt(c.substring(0, 2), 16)
    const g = parseInt(c.substring(2, 4), 16)
    const b = parseInt(c.substring(4, 6), 16)
    const toLinear = (v: number) => {
      const s = v / 255
      return s <= 0.04045 ? s / 12.92 : Math.pow((s + 0.055) / 1.055, 2.4)
    }
    const luminance = 0.2126 * toLinear(r) + 0.7152 * toLinear(g) + 0.0722 * toLinear(b)
    return luminance > 0.179 ? '#000000' : '#ffffff'
  }

  return { getContrastColor }
}
